<template>
  <section class="todo" v-if="tasks">
    <div class="d-flex flex-column container" ref="actionsTODO">
      <div class="card task" v-if="enabledNotificationsTask">
       <div class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center">
         <div class="row align-items-center w-100" @click="showNotificationModal = true">
            <div class="col-12 col-lg-2 icon">
              <div v-html="icons.notifications"></div>
            </div>
            <div class="col-12 col-lg-7 description">
              <strong>Attiva le notifiche per {{$store.state.brand.name}}</strong>
              <br>
            </div>
            <div
              class="col-12 col-lg-3 text-center cta">
              <a class="btn">Attiva!</a>
            </div>
            </div>
       </div>
      </div>
      <div
        class="card task"
        v-if="tasks && (index < max || !limitActions)"
        v-for="(task,index) in tasks"
        :key="index"
        :class="[task.type.replace('.','-'),(task.type==='identity.touchpoint')?task.data.provider:null,(task.type==='athena.facebook')?'identity-touchpoint':null]"
      >
        <task
          class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center"
          :task.sync="task"
          :messages.sync="messages"
        ></task>
      </div>
      <div
        class="moreActions text-center"
        v-if="tasks && tasks.length>(max*page)"
      >
        <router-link :to="moreactions" v-if="!paginated" class="a-more btn-not-spinner">{{$t('Show More')}}</router-link>
        <a href="#" @click="addPage" v-else class="a-more btn-not-spinner">{{$t('Show More')}}</a>
      </div>
    </div>
    <information-modal @closeInformationModal="showNotificationModal = false" v-if="showNotificationModal && defaultModal" @readInformation="askForNotificationPermissions" content="Attiva le notifiche, sono bellissime!" title="Attiva le notifiche" cta="Attivale!"></information-modal>
    <information-modal @closeInformationModal="showNotificationModal = false" v-if="showNotificationModal && !defaultModal" @readInformation="askForNotificationPermissions" content="Ecco come attivare le notifiche!" title="Attiva le notifiche" cta="Attivale!"></information-modal>
  </section>
</template>
<script>
import Task from "./Task";
import InformationModal from "./InformationModal"
import iconNotifications from "../../assets/svg/fnz_notifications.svg"
export default {
  name: 'action-todo-nos-wipe',
  components: {
    Task,
    InformationModal
  },
  props: {
    tasks: { default: null },
    moreactions: { default: "#" },
    max: { default: 3 },
    limitActions: {default: false},
    paginated: { default: false },
    messages:{
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    enabledNotificationsTask()
    {
      return !this.acceptedNotifications && typeof(Notification) !== 'undefined' && Notification.permission !== 'granted' && this.$messaging
    },
    defaultModal()
    {
      return typeof(Notification) !== 'undefined' && Notification.permission === 'default' && this.messaging
    }
  },
  data() {
    return {
      pointer: 0,
      page: 1,
      icons: {
        notifications: iconNotifications
      },
      showNotificationModal: false,
      acceptedNotifications: false,
    };
  },
  methods: {
    addPage(e) {
      if (e) e.preventDefault();
      if (this.tasks && this.tasks.length > this.max * this.page) this.page++;
    },
    askForNotificationPermissions()
    {
      this.$messaging
        .requestPermission()
        .then(() => this.$messaging.getToken())
        .then((token) => {
            this.pushDeviceInfo(token, 'web-firebase');
            this.acceptedNotifications = true;
        })
        .catch(function(err) {
            console.log("Unable to get permission to notify.", err);
        });
    }
  }
};
</script>